import { Dispatch } from "redux";
import { AppStateWithData } from "../../AppStateWithData";
import { GetTextToAutocomplete, getTextToAutocomplete } from "../../../api/inputAutocompleteUtils/getTextToAutocomplete";
import { getUsersInputAutocomplete } from "../../../api/inputAutocompleteUtils/getUsersAutocomplete";
import { webGetTagsAutocomplete } from "../../../api/inputAutocompleteUtils/getTagsAutocomplete";
import { ApiConfig } from "../../../config";

export type AutocompleteType = 'user' | 'tag'
export const UPDATE_INPUT_AUTOCOMPLETE = 'UPDATE_INPUT_AUTOCOMPLETE'
export interface UpdateInputAutocompleteAction {
    type: string
    items: any[]
    autocompleteType?: AutocompleteType
}
export const createUpdateInputAutocompleteAction = <T>(items: any[], autocompleteType?: AutocompleteType): UpdateInputAutocompleteAction => ({
    type: UPDATE_INPUT_AUTOCOMPLETE,
    autocompleteType,
    items
})


export interface __SetInputAutocompleteParameters {
    getTextToAutocomplete: GetTextToAutocomplete
    getAutocompleteItems: (text: string) => Promise<any[]>
    trigger: string
    type: AutocompleteType
}

export const __setInputAutocompleteText = <T>(parameters: __SetInputAutocompleteParameters) =>
    (text: string) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const { getAutocompleteItems, getTextToAutocomplete, trigger, type } = parameters
        const wordToComplete = getTextToAutocomplete(text, trigger)
        if (!wordToComplete) {
            dispatch(createUpdateInputAutocompleteAction([], type))
        } else {
            const items = await getAutocompleteItems(wordToComplete)
            dispatch(createUpdateInputAutocompleteAction(items, type))
        }
    }

const getAutocompleteItemsForTags = (text: string) => Promise.resolve([])

export const __setInputAutocompleteForUsers = (text: string) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
    return dispatch<any>(__setInputAutocompleteText({
        getAutocompleteItems: getUsersInputAutocomplete(getState()),
        getTextToAutocomplete: getTextToAutocomplete,
        trigger: '@',
        type: 'user'
    })(text))
}

export const __setInputAutocompleteForTags = (config: ApiConfig) => (text: string) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
    return dispatch<any>(__setInputAutocompleteText({
        getAutocompleteItems: webGetTagsAutocomplete(getState(), config),
        getTextToAutocomplete: getTextToAutocomplete,
        trigger: '#',
        type: 'tag'
    })(text))
}

export const setInputAutocomplete = (config: ApiConfig) => (text: string) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const autocompleteUser = getTextToAutocomplete(text, '@')
    if (autocompleteUser) {
        return dispatch<any>(__setInputAutocompleteForUsers(text))
    }

    const autocompleteTag = getTextToAutocomplete(text, '#')
    if (autocompleteTag) {
        return dispatch<any>(__setInputAutocompleteForTags(config)(text))
    }

    if (getState().data.inputAutocomplete.type) {
        return dispatch<any>(createUpdateInputAutocompleteAction([]))
    }
}